// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { t16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-t': IconT;
    }
}

/**
 * The icon component for the 't' icon
 */
export class IconT extends Icon {
    public constructor() {
        super(t16X16);
    }
}

registerIcon('icon-t', IconT);
export const iconTTag = 'nimble-icon-t';
